<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
<!--            <a-col :md="8" :sm="24">-->
<!--              <a-form-item label="发布人｛hospital.id;depart.id;doctor.id｝" prop="publisher">-->
<!--                <a-input v-model="queryParam.publisher" placeholder="请输入发布人｛hospital.id;depart.id;doctor.id｝" allow-clear/>-->
<!--              </a-form-item>-->
<!--            </a-col>-->
            <a-col :md="8" :sm="24">
              <a-form-item label="标题" prop="title">
                <a-input v-model="queryParam.title" placeholder="请输入标题" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="状态" prop="status">
                <a-select v-model="queryParam.status" placeholder="请选择状态" allow-clear>
                  <a-select-option value="0">待审核</a-select-option>
                  <a-select-option value="1">通过</a-select-option>
                  <a-select-option value="-1">驳回</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <template v-if="advanced">

            </template>
            <a-col :md="!advanced && 8 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
<!--                <a @click="toggleAdvanced" style="margin-left: 8px">-->
<!--                  {{ advanced ? '收起' : '展开' }}-->
<!--                  <a-icon :type="advanced ? 'up' : 'down'"/>-->
<!--                </a>-->
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="primary" @click="$refs.videoUploadForm.handleAdd()" v-hasPermi="['article:article:add']">
          <a-icon type="video-camera" />上传视频
        </a-button>
        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['article:article:remove']">
          <a-icon type="delete" />删除
        </a-button>
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />
      <!-- 上传视频 -->
      <video-upload-form
        ref="videoUploadForm"
        @ok="getList"
      />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="image" slot-scope="text, record">
          <img v-viewer v-if="record.imageArr" v-for="(item, index) in record.imageArr.split(',')" :key="index" :src="processImageUrl(item)" style="width: 100px; height: 100px;">
        </span>
        <span slot="avatar" slot-scope="text, record">
          <img v-viewer v-if="record.avatar" :src="processImageUrl(record.avatar)" style="width: 100px; height: 100px;">
          <span v-else>-</span>
        </span>
        <span slot="video" slot-scope="text,record">
          <video v-if="record.type == 2 && record.videoUrl" :src="processImageUrl(record.videoUrl)" controls="controls" style="width: 100px; height: 100px;"></video>
          <span v-else>-</span>
        </span>
        <span slot="operation" slot-scope="text, record">

          <a v-if="record.status == 0" @click="$refs.createForm.handleUpdate(record, undefined)" v-hasPermi="['article:article:check']">
            <a-icon type="edit" />审核
          </a>

          <a v-if="record.status == 1 && record.type == 2" @click="$refs.videoUploadForm.handleUpdate(record)" v-hasPermi="['article:article:edit']">
            <a-icon type="edit" />编辑
          </a>

          <a @click="$refs.createForm.handleInfo(record)" v-hasPermi="['article:article:query']">
            <a-icon type="search" />详情
          </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageArticle,listArticle, delArticle } from '@/api/article/article'
import CreateForm from './modules/CreateForm'
import VideoUploadForm from './modules/VideoUploadForm'
import { tableMixin } from '@/store/table-mixin'
import { processImageUrl } from '@/utils/util'

export default {
  name: 'Article',
  components: {
    CreateForm,
    VideoUploadForm
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        publisher: null,
        publisherType: null,
        type: null,
        title: null,
        content: null,
        imageArr: null,
        videoUrl: null,
        status: null,
        rejectReason: null,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        // {
        //   title: 'id',
        //   dataIndex: 'id',
        //   ellipsis: true,
        //   align: 'center'
        // },
        {
          title: '发布人',
          dataIndex: 'publisherName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '头像',
          dataIndex: 'avatar',
          ellipsis: true,
          align: 'center',
          scopedSlots: { customRender: 'avatar' }
        },
        {
          title: '发布人类型',
          dataIndex: 'publisherType',
          ellipsis: true,
          align: 'center',
          customRender: (f) => {
            if (f === 1) {
              return '医院'
            } else if (f === 2) {
              return '科室'
            } else if (f === 3) {
              return '医师'
            } else {
              return '平台'
            }
          }
        },
        {
          title: '类型',
          dataIndex: 'type',
          ellipsis: true,
          align: 'center',
          customRender: (f) => {
            if (f === 1) {
              return '文章'
            } else {
              return '视频'
            }
          }
        },
        {
          title: '标题',
          dataIndex: 'title',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '正文',
          dataIndex: 'content',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '封面',
          dataIndex: 'imageArr',
          scopedSlots: { customRender: 'image' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '视频',
          dataIndex: 'videoUrl',
          ellipsis: true,
          scopedSlots: { customRender: 'video' },
          align: 'center'
        },
        {
          title: '状态',
          dataIndex: 'status',
          ellipsis: true,
          align: 'center',
          customRender: function (text) {
            if (text === 0) {
              return '待审核'
            } else if (text === 1) {
              return '通过'
            } else if (text === -1) {
              return '驳回'
            }
          }
        },
        {
          title: '驳回原因',
          dataIndex: 'rejectReason',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '发布时间',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          ellipsis: true,
          align: 'center'
        },
        // {
        //   title: '备注',
        //   dataIndex: 'remark',
        //   ellipsis: true,
        //   align: 'center'
        // },
        {
          title: '操作',
          dataIndex: 'operation',
          width: '18%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  filters: {
  },
  created () {
    this.getList()
  },
  computed: {
  },
  watch: {
  },
  methods: {
    processImageUrl,
    /** 查询文章、视频列表 */
    getList () {
      this.loading = true
     pageArticle(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        publisher: undefined,
        publisherType: undefined,
        type: undefined,
        title: undefined,
        content: undefined,
        imageArr: undefined,
        videoUrl: undefined,
        status: undefined,
        rejectReason: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if(row.id){
        this.ids.push(row.id)
      }
      this.$confirm({
        title: '确认删除所选中数据?',
        content: '当前选中编号为' + ids + '的数据',
        onOk () {
          let data = []
          that.ids.map(id => data.push({"id":id}))
          return delArticle(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                '删除成功',
                3
              )
          })
        },
        onCancel () {
          //取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk () {
          that.download('article/article/export', {
            ...that.queryParam
          }, `文章、视频_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    }
  }
}
</script>
